import { Box, Popover, styled } from "@mui/material";

export const NotificationLayout = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    height: "460px",
    width: "420px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
    boxShadow: theme.shadows[1],
    paddingBottom: theme.spacing(2),
}));

export const NotificationPopoverStyles = styled(Popover)(({ theme }) => ({
    "& .MuiPaper-root": {
        boxShadow: theme.shadows[6],
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        marginTop: theme.spacing(1),
        overflow: "visible",
        padding: theme.spacing(2),
        border: `1px solid ${theme.palette.divider}`,
    },
}));

export const SingleNotificationContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "read",
})<{ read: boolean }>(({ read, theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: read
        ? theme.palette.action.selected
        : theme.palette.action.hover,
    borderLeft: `4px solid ${read ? theme.palette.grey[300] : theme.palette.primary.main
        }`,
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
        backgroundColor: theme.palette.action.selected,
    },
}));

export const NotificationTitle = styled(Box)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
}));

export const NotificationMessage = styled(Box)(({ theme }) => ({
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
    a: {
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        marginLeft: theme.spacing(0.5),
        '&:hover': {
            textDecoration: 'none',
        },
    },
}));

export const NotificationDate = styled(Box)(({ theme }) => ({
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.disabled,
    fontStyle: "italic",
    marginTop: theme.spacing(0.5),
    minHeight: theme.spacing(2),
}));

export const NotificationBody = styled(Box)(() => ({
    flexGrow: 1,
}));

export const NotificationsContainer = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    overflowY: "auto",
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(3),
}));

export const NotificationHeaderContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1, 0),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    backgroundColor: theme.palette.grey[100],
}));

export const HeaderMenuPoint = styled(Box, {
    shouldForwardProp: (prop) => prop !== "selected",
})<{ selected: boolean }>(({ selected, theme }) => ({
    padding: theme.spacing(1, 0),
    textAlign: "center",
    width: "100%",
    transition: "background-color 0.3s ease",
    backgroundColor: selected ? theme.palette.action.hover : "transparent",
    borderBottom: selected ? `2px solid ${theme.palette.primary.main}` : "none",
    fontWeight: selected ? "bold" : "normal",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: theme.palette.action.selected,
    },
}));

export const PaginationContainer = styled(Box)(({ theme }) => ({
    textAlign: "center",
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1),
    width: "90%",
    marginTop: "auto",
    display: "flex",
    justifyContent: "center"
}))

export const PaginationElement = styled(Box, {
    shouldForwardProp: (prop) => prop !== "active",
})<{ active?: boolean }>(({ active }) => ({
    width: "30px",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: "4px",
    padding: "2px 4px",
    fontWeight: active ? "bold" : "normal",
    backgroundColor: active ? "#e0e0e0" : "transparent",
    '&:hover': {
        backgroundColor: '#f5f5f5',
    },
    '&.disabled': {
        pointerEvents: "none",
        opacity: 0.5,
    },
}));
